import { Component } from '@angular/core';

type Environment = 'dev' | 'staging' | null;

const ENV_BANNER_HEIGHT = '28px';

function detectEnvironment(): Environment {
  const hostname = window.location.hostname;
  if (hostname.includes('pkvdev')) {
    return 'dev';
  }
  if (hostname.includes('staging')) {
    return 'staging';
  }
  return null;
}

@Component({
  selector: 'app-environment-banner',
  imports: [],
  templateUrl: './environment-banner.html'
})
export class EnvironmentBanner {
  protected readonly env: Environment = detectEnvironment();

  constructor() {
    if (this.env) {
      document.documentElement.style.setProperty('--env-banner-height', ENV_BANNER_HEIGHT);
    }
  }
}
